"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDevPortalSelector = exports.hasScopeSelector = void 0;

var _AuthAdminSelectors = require("pricing-pages-unified-ui/selectors/AuthAdminSelectors");

var _Scopes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/Scopes"));

var hasScopeSelector = function hasScopeSelector(state, scope) {
  var auth = (0, _AuthAdminSelectors.authSelector)(state);
  return auth && auth.user && auth.user.scopes && auth.user.scopes.indexOf(scope) > -1;
};

exports.hasScopeSelector = hasScopeSelector;

var isDevPortalSelector = function isDevPortalSelector(state) {
  var doesntHaveCRMAccess = !hasScopeSelector(state, _Scopes.default.CRM_ACCESS) || !hasScopeSelector(state, _Scopes.default.CONTACTS_READ);
  var isBillingAdmin = (0, _AuthAdminSelectors.isBillingAdminSelector)(state);
  return doesntHaveCRMAccess && !isBillingAdmin;
};

exports.isDevPortalSelector = isDevPortalSelector;